import { render, staticRenderFns } from "./ManagePro.vue?vue&type=template&id=3e108e54&scoped=true"
import script from "./ManagePro.vue?vue&type=script&lang=js"
export * from "./ManagePro.vue?vue&type=script&lang=js"
import style0 from "./ManagePro.vue?vue&type=style&index=0&id=3e108e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e108e54",
  null
  
)

export default component.exports